import Hero from "@/components/Hero";
import StackMarquee from "@/components/StackMarquee";
import ServicesGrid from "@/components/ServicesGrid";
import IndustriesSection from "@/components/IndustriesSection";
import ProcessSection from "@/components/ProcessSection";
import CaseStudiesSection from "@/components/CaseStudiesSection";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";

export default function HomePage() {
  return (
    <>
      <Hero />
      <StackMarquee />
      <ServicesGrid compact />
      <IndustriesSection />
      <ProcessSection />
      <CaseStudiesSection />
      <Testimonials />
      <CTASection />
    </>
  );
}
